import { getBaseUrl } from '@dolfin/utils/environment'
import { MessagingAction } from '.'
import { EmailActionNode } from '../../node/types'

export class EmailMessagingAction extends MessagingAction<EmailActionNode> {
  async run() {
    const data = this.parseVariables()
    const { subject, title, text, message_type } = data ?? {}

    if (!subject || !title || !text || !message_type) {
      console.error('Missing required fields for email action', data)
      return false
    }

    const from = process.env.NEXT_PUBLIC_EMAIL_FROM ?? 'info@heydolfin.com'
    const dealOwnerId = this.recordData.getDealOwnerId()
    const to = dealOwnerId && (await this.rpcClient.getOwnerEmail(dealOwnerId))

    if (!to) {
      console.error('No owner email found')
      return false
    }

    const res = await fetch(getBaseUrl() + '/api/emails/node-message', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ from, to, subject, message_type, title, text })
    })

    if (!res.ok) {
      const error = await res.json()
      console.error('Error sending email', error)
    }

    return res.ok
  }
}
